import { Injectable } from "@angular/core";
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, finalize, retry, tap } from "rxjs/operators";
import { LoaderService } from "../_services/loader.service";

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private url = "";
  constructor(private loaderService: LoaderService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // preluam url-ul la fiecare request
    if (request instanceof HttpRequest) {
      this.url = request.url;
    }

    // cand nu se doreste afisarea loader-ului
    const noLoader = request.params.get("noLoader");
    if (noLoader) {
      if (noLoader === "false") {
        this.loaderService.show();
      }
    } else {
      this.loaderService.show();
    }

    return next.handle(request).pipe(
      finalize(() => {
        // la requesturile de login si logout vrem ca loader-ul sa nu fie ascuns, decat dupa ce toate requesturile au fost rezolvate
        if ((!this.url.includes("logout") && (!noLoader || noLoader === "false"))
              || this.url === "") {
          this.loaderService.hide();
        } else {
          this.loaderService.requestCount--;
        }
        this.url = "";
      })
    );
  }
}
